import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  wrapper: {
    backgroundColor: '#222222',
    padding: '15px 0',
  },
  text: {
    width: '80%',
    maxWidth: 1080,
    margin: 'auto',
    color: '#666666',
    fontFamily: 'OpenSansRegular',
    fontSize: 14,
    lineHeight: '1.7em',
  },
});

function Footer() {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <Typography className={classes.text}>© 2020 CredibleMind</Typography>
    </div>
  );
}

export default Footer;
